export default __webpack_public_path__ + "static/backgroundHome--blurH-2af5cd30135d3ff0c646f5b23307e900.webp";